import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { FavoritesProvider } from './context/FavoritesContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CollectionsPage from './pages/CollectionsPage';
import { AboutPage, ContactPage } from './pages/AboutContactPages';
import LoginPage from './pages/LoginPage';
import FavoritesPage from './pages/FavoritesPage';
import CareGuidePage from './pages/CareGuidePage';
import OrdersPage from './pages/OrdersPage';
import CheckoutPage from './pages/CheckoutPage';
import AdminPage from './pages/AdminPage';
import AccountPage from './pages/AccountPage';
import AuthCallback from './components/auth/AuthCallback';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import { trackEvent } from './hooks/useAnalytics';

// Analytics tracker component
const AnalyticsTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view on route change
    trackEvent({
      event_type: 'page_view',
      page: location.pathname,
      metadata: { search: location.search }
    });
  }, [location]);
  
  return null;
};

function AppContent() {
  return (
    <div className="App">
      <AnalyticsTracker />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/koleksiyonlar" element={<CollectionsPage />} />
        <Route path="/koleksiyonlar/:slug" element={<CollectionsPage />} />
        <Route path="/urunler" element={<ProductsPage />} />
        <Route path="/urun/:id" element={<ProductDetailPage />} />
        <Route path="/sepet" element={<CartPage />} />
        <Route path="/odeme" element={<CheckoutPage />} />
        <Route path="/siparislerim" element={<OrdersPage />} />
        <Route path="/hakkimizda" element={<AboutPage />} />
        <Route path="/iletisim" element={<ContactPage />} />
        <Route path="/giris" element={<LoginPage />} />
        <Route path="/hesabim" element={<AccountPage />} />
        <Route path="/favoriler" element={<FavoritesPage />} />
        <Route path="/bakim" element={<CareGuidePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/sifremi-unuttum" element={<ForgotPasswordPage />} />
        <Route path="/sifre-sifirla/:token" element={<ResetPasswordPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <FavoritesProvider>
            <AppContent />
          </FavoritesProvider>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
